'use es6';

export var STANDARD_CACHE = 'i18n-cached-standard-locales';
export var PUBLIC_CACHE = 'i18n-cached-public-locales';